/* eslint-disable max-lines-per-function */
import { ArbeitsbereichStation } from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';
import { RowDivider } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/desktop/components/RowDivider';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerTitle,
  DrawerTrigger,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@e2n/ui';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function KonfliktIndicator({
  konfliktStationen,
}: {
  konfliktStationen: ArbeitsbereichStation[];
}) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (konfliktStationen.length === 0) {
    return null;
  }

  const label = t(
    'domain.mitarbeiter.rotationsplan.rotationsplaene.konflikt.count',
    { count: konfliktStationen.length },
  );

  const trigger = (
    <Button
      variant="ghost"
      size="sm"
      aria-label={label}
      className="py-1 text-primary-red-400 hover:bg-neutrals-200">
      <FontAwesomeIcon icon={faCircleExclamation} />
      <span className="ml-1 text-xs font-normal">{label}</span>
    </Button>
  );

  const konfliktList = konfliktStationen.map((station, index) => (
    <>
      <div
        key={station.id}
        className="flex items-center justify-between gap-6 text-sm">
        <div className="flex items-center min-w-0 gap-2">
          <FontAwesomeIcon
            icon={faCircle}
            color={station.arbeitsbereich.getBorderColor()}
            size="xs"
          />
          <div className="truncate">{station.arbeitsbereich.name}</div>
        </div>
        <div className="whitespace-nowrap">
          {dayjs(station.von).format('DD.MM') +
            ' - ' +
            dayjs(station.bis).format('DD.MM.YYYY')}
        </div>
      </div>
      {index < konfliktStationen.length - 1 && <RowDivider />}
    </>
  ));

  return (
    <>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger
          className="hidden md:flex"
          asChild
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}>
          {trigger}
        </PopoverTrigger>
        <PopoverContent
          side="right"
          align="center"
          onMouseEnter={() => setOpen(true)}
          onMouseLeave={() => setOpen(false)}
          className="flex flex-col w-full gap-2 p-3 text-sm bg-neutrals-100 md:min-w-85 text-neutrals-900">
          {konfliktList}
        </PopoverContent>
      </Popover>
      <Drawer>
        <DrawerTrigger className="flex md:hidden" asChild>
          {trigger}
        </DrawerTrigger>
        <DrawerContent>
          <DrawerTitle className="text-center pt-3 pb-1">{label}</DrawerTitle>
          <div className="flex flex-col gap-2 p-4 text-sm text-neutrals-900">
            {konfliktList}
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
}
